import React from 'react';
import classNames from 'classnames';

const SendStatus = ({ className, sendStatus, style }) => (
  sendStatus ? (
    <div className={classNames(
      className,
      `send-status ${sendStatus}`
      )}
      style={style}
    >
      {sendStatus}
    </div>
  ) : null);

export default SendStatus;



// WEBPACK FOOTER //
// ./src/Welcome/SendStatus.js